import { c as _c } from "react/compiler-runtime";
/**
 * @file SelectedRowsPopupComponent.tsx
 * @description
 * -----------------------------------------------------
 * Componente Popup
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created unknown
 * @modified 2025-07-31
 * @author DLTCode
 * @author Ismael Benabdellah
 * @author Pedro Luis Gómez
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

import { useEffect } from "react";
import { SelectedRowsPopupProps } from "@/types/ui";
import { useTranslations } from "next-intl";
import { X } from "lucide-react";
const SelectedRowsPopupComponent = t0 => {
  const $ = _c(34);
  const {
    selectedRows,
    onClear,
    children,
    onVisibilityChange
  } = t0;
  const t = useTranslations("SelectedRowsPopupComponent");
  let t1;
  if ($[0] !== onVisibilityChange || $[1] !== selectedRows.length) {
    t1 = () => {
      if (onVisibilityChange) {
        onVisibilityChange(selectedRows.length > 0);
      }
    };
    $[0] = onVisibilityChange;
    $[1] = selectedRows.length;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onVisibilityChange || $[4] !== selectedRows) {
    t2 = [selectedRows, onVisibilityChange];
    $[3] = onVisibilityChange;
    $[4] = selectedRows;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== onClear) {
    t3 = () => onClear;
    $[6] = onClear;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  if (selectedRows.length === 0) {
    return null;
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("close");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("close");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <X role="img" aria-hidden={true} className="selected-rows__clear__icon" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onClear || $[15] !== t5 || $[16] !== t6) {
    t8 = <button className="selected-rows__clear" onClick={onClear} aria-label={t5} title={t6} tabIndex={0}>{t7}</button>;
    $[14] = onClear;
    $[15] = t5;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== selectedRows.length) {
    t9 = <strong>{selectedRows.length}</strong>;
    $[18] = selectedRows.length;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = selectedRows.length > 1 ? "more" : "one";
  let t11;
  if ($[20] !== t || $[21] !== t10) {
    t11 = t(t10);
    $[20] = t;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9) {
    t12 = <p className="selected-rows__number" tabIndex={0} role="note">{t9}{" "}{t11}</p>;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t8) {
    t13 = <section className="selected-rows__close">{t8}{t12}</section>;
    $[26] = t12;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== children) {
    t14 = children && <section className="selected-rows__actions">{children}</section>;
    $[29] = children;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <section className="selected-rows" role="region" aria-live="polite"><section className="selected-rows__section">{t13}{t14}</section></section>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
export default SelectedRowsPopupComponent;